import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
      {categories.map((c) => (
        <a
          key={c.id}
          href={c.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${c.icon} text-base`}></i>
          </span>
          <span className="truncate text-sm font-medium text-foreground-800 whitespace-nowrap">
            {t(c.nameKey)}
          </span>
          <span className="ml-auto flex h-5 w-5 shrink-0 items-center justify-center text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600">
            <i className="ri-arrow-right-s-line text-base"></i>
          </span>
        </a>
      ))}
    </div>
  );
}